/* 端内相关方法 */
import { monitorRequest } from './appTools'
import { queryParams } from '../tools'
import { ErrorType, ErrorLevel } from '../contains'
import { PROJECTNAME } from '../const'

// 端内SDK上报类型
const MONITORREQUESTTYP = {
  page: 1,
  resource: 2,
  error: 3,
}

const originUrl = window.location.origin + window.location.pathname

// app page 上报
export function pageManagerReport(page) {
  page.ext = getResultObj(page?.ext)
  ;(page.evs || []).forEach((item) => {
    item.url = originUrl
  })
  page.project = PROJECTNAME
  console.log('test_page111', page)
  monitorRequest(MONITORREQUESTTYP['page'], page)
}

// app resource 上报
export function resManagerReport(res) {
  res.evs = getResultObj(res?.evs)
  const { nt, sdkEnv } = res || {}
  const resource = {
    evs: handleResEvs(res),
    sdkEnv,
    nt: nt || 0,
  }
  console.log('test_resource111', resource)
  monitorRequest(MONITORREQUESTTYP['resource'], resource)
}

// app error 上报
export function errManagerReport(error) {
  if (error.errorType === 'apiError') return
  let errorList = []
  try {
    errorList = JSON.parse(localStorage.getItem('errorList') || '[]')
  } catch (err) {
    console.log(err)
  }
  const msg = error?.errorInfo.msg
  if (errorList.some((item) => msg.indexOf(item) !== -1)) return
  error.ext = getResultObj(error?.ext)
  error.url = originUrl
  console.log('test_error111', error)
  monitorRequest(MONITORREQUESTTYP['error'], error)
}

/**
 * Bridge建联失败时上报
 * @param customErrorReport
 */
export function BridgeConnectReport(customErrorReport) {
  // 端内：BridgeConnectError
  setTimeout(() => {
    if (!(window).AmapApp) {
      customErrorReport({
        name: 'BridgeConnectError',
        msg: 'bridge建连失败',
        errorType: ErrorType.customError,
        level: ErrorLevel.error,
      })
    }
  }, 1000)
}

// 工具函数：json字符串转换Json
export function getResultObj(content) {
  if (content && typeof content === 'string') {
    return JSON.parse(content)
  } else {
    return content || {}
  }
}
// 工具函数：app resource 上报 参数处理
export const handleResEvs = (res) => {
  return ((res && res.evs) || []).filter((items) => {
    delete items.traceId
    items.requestTime = items.requestTime || 0
    items.pageTraceId = queryParams.pageTraceId || ''
    items.project = PROJECTNAME
    return items.resourceType !== 'api'
  })
}
